module.exports = __webpack_public_path__ + "media/assets/avia/sidebar/location-526f392a03c76a31bf1046f44db3623a.png";